import styled from 'styled-components';

import { useCustomTheme } from '../../styles';


type ControlsLayoutProps = {
	centered?: boolean;
}

const Root = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;
`;

const WrapLayout = styled.div`
	width: 100%;
	height: auto;
`;

const IconLayout = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	flex-flow: column wrap;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
`;

const TitleLayout = styled.div`
	margin-bottom: 30px;
`;

const Title = styled.div`
	font-size: 14px;
	font-weight: 500;
	line-height: 1.43;
	text-align: center;
`;

const Detail = styled.div`
	font-size: 14px;
	line-height: 1.43;
	text-align: center;
	margin-top: 5px;

	${p => `
		color: ${useCustomTheme(p)[0].palette.blackSecondary};
	`}
`;

const ControlsLayout = styled.div<ControlsLayoutProps>`
	position: relative;
	width: 100%;
	height: auto;
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;

	${p => p.centered && `
		justify-content: center;
	`}
`;

const ButtonLayout = styled.div`
	margin-right: 20px;

	&:last-child {
		margin-right: 0;
	}
`;


export {
	Root,
	WrapLayout,
	IconLayout,
	TitleLayout,
	Title,
	Detail,
	ControlsLayout,
	ButtonLayout,
};
